import { render, staticRenderFns } from "./page-order-money.vue?vue&type=template&id=6cb3c559&scoped=true"
import script from "./page-order-money.vue?vue&type=script&lang=js"
export * from "./page-order-money.vue?vue&type=script&lang=js"
import style0 from "./page-order-money.vue?vue&type=style&index=0&id=6cb3c559&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cb3c559",
  null
  
)

export default component.exports